import { CumulativeBooster } from "../cumulative_booster.js";
import { CumulativeBoosterID } from "../cumulative_booster_id.js";

export interface BigBallBoosterContext
{
  setCannonBallModifiers( size_multiplier: number, mass_multiplier: number ): void;
  setBigBallChargeActive( active: boolean ): void;
}

export class BigBallBooster extends CumulativeBooster<BigBallBoosterContext>
{
  public static readonly DEFAULT_SIZE_MULTIPLIER = 2.5;
  public static readonly DEFAULT_MASS_MULTIPLIER = 10;
  public static readonly DEFAULT_SHOTS_PER_USE = 1;

  public readonly sizeMultiplier: number;
  public readonly massMultiplier: number;
  public readonly shotsPerUse: number;

  private shots_remaining = 0;

  public constructor(
    size_multiplier = BigBallBooster.DEFAULT_SIZE_MULTIPLIER,
    mass_multiplier = BigBallBooster.DEFAULT_MASS_MULTIPLIER,
    shots_per_use = BigBallBooster.DEFAULT_SHOTS_PER_USE
  )
  {
    super( CumulativeBoosterID.BigBall );

    if ( !Number.isFinite( size_multiplier ) || size_multiplier <= 0 )
      throw new Error( "Big ball size multiplier must be a finite positive number" );

    if ( !Number.isFinite( mass_multiplier ) || mass_multiplier <= 0 )
      throw new Error( "Big ball mass multiplier must be a finite positive number" );

    if ( !Number.isFinite( shots_per_use ) || shots_per_use <= 0 )
      throw new Error( "Big ball shots per use must be a finite positive number" );

    this.sizeMultiplier = size_multiplier;
    this.massMultiplier = mass_multiplier;
    this.shotsPerUse = Math.floor( shots_per_use );
  }

  public onBallFired(): void
  {
    if ( !this.isActive )
      return;

    this.shots_remaining--;
    if ( this.shots_remaining <= 0 )
      this.complete();
  }

  protected override onActivate( context: BigBallBoosterContext ): void
  {
    this.shots_remaining = this.shotsPerUse;
    context.setCannonBallModifiers( this.sizeMultiplier, this.massMultiplier );
    context.setBigBallChargeActive( true );
  }

  protected override onDeactivate( context: BigBallBoosterContext, _cancelled: boolean ): void
  {
    context.setCannonBallModifiers( 1, 1 );
    context.setBigBallChargeActive( false );
  }

  protected override onReset(): void
  {
    this.shots_remaining = 0;
  }
}
